export default {
  purchaseList: [],
  purchaseInfo: {},
  unClosedPurchaseCount: 0,
  unPaidPurchaseCount: 0
}
